import React from "react";
import styles from "./UserInfo.module.scss";

const UserInfo = ({ name, email, avatar }) => {
    return (
        <div className={styles.userInfo}>
            <img className={styles.userAvatar} src={avatar} alt={`${name}'s avatar`} />
            <div className={styles.userDetails}>
                <div className={styles.userName}>{name}</div>
                <div className={styles.userEmail}>{email}</div>
            </div>
        </div>
    );
};

export {UserInfo};
